export default __webpack_public_path__ + "static/media/exit-logo.222b52f9.svg";